module.exports = __webpack_public_path__ + "img/7.b3fb6bfe.jpg";